import axios from "axios";
import React, { useEffect, useState } from "react";
import DOMPurify from 'dompurify';
import {Link, useParams} from 'react-router-dom';
import RecentBlog from "../component/RecentBlog";
import { useSettings } from '../SettingsContext';

const BlogDetails = () => {
    const setting = useSettings();
    const { slug } = useParams();
    const [blog,setBlog] = useState([]);
    const backendBaseUrl = process.env.REACT_APP_BACKEND_BASE_URL;
    useEffect(() =>{
        const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
        const Url = process.env.REACT_APP_API_BLOG_DETAILS;
        axios.get(`${apiBaseUrl}${Url}/${slug}`)
            .then(response => setBlog(response.data))
            .catch(error => console.error("Error fetching API",error));
    },[slug]);

    const [visaTypes,setVisaTypes] = useState([]);
    useEffect(() =>{
        const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
        const Url = process.env.REACT_APP_API_VISA_TYPE;
        axios.get(`${apiBaseUrl}${Url}`)
            .then(response => setVisaTypes(response.data))
            .catch(error => console.error("Error fetching API",error));
    },[]);

    return (
        <main className="main">

            <div className="site-breadcrumb" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets/img/breadcrumb/01.jpg)`}}>
                <div className="container">
                    <h2 className="breadcrumb-title">{blog?.title}</h2>
                    <ul className="breadcrumb-menu">
                        <li>
                            <Link className="nav-link" to={"/"}>হোম</Link>
                        </li>
                        <li className="active">{blog?.title}</li>
                    </ul>
                </div>
            </div>

            <div className="blog-single py-100">
                <div className="container">
                    <div className="row g-4">
                        <div className="col-lg-8">
                            <div className="blog-single-wrap">
                                <div className="blog-single-content">
                                    <div className="blog-thumb-img">
                                        <img src={`${backendBaseUrl}${blog?.image}`} alt="Thumb" />
                                    </div>
                                    <div className="blog-info">
                                        <div className="blog-details">
                                            <h4 className="blog-details-title mb-20">{blog?.title}</h4>
                                            <div className="site-heading mb-10" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(blog?.long_description) }}>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <aside className="blog-sidebar">
                                <div className="widget category">
                                    <h5 className="widget-title">ভিসার ধরন </h5>
                                    <div className="category-list">
                                        {visaTypes.map((visaType, index) => {
                                            return (
                                                <Link className={'text-decoration-none'} to={`/visa/${visaType.slug}`}><i className="far fa-arrow-right"></i> {visaType?.name}</Link>
                                            );
                                        })}

                                    </div>
                                </div>
                                <RecentBlog />
                                <div className="widget social">
                                    <h5 className="widget-title">Follow Us</h5>
                                    <div className="social-link">
                                        {setting?.facebook && (
                                            <a href={setting?.facebook || '#'} target="_blank"><i className="fab fa-facebook-f"></i></a>
                                        )}
                                        {setting?.youtube && (
                                            <a href={setting?.youtube || '#'} target="_blank"><i className="fab fa-youtube"></i></a>
                                        )}
                                        {setting?.instagram && (

                                            <a href={setting.instagram} target="_blank" rel="noopener noreferrer">
                                                <i className="fab fa-instagram"></i>
                                            </a>

                                        )}
                                        {setting?.linkedIn && (

                                            <a href={setting.linkedIn} target="_blank" rel="noopener noreferrer">
                                                <i className="fab fa-linkedin-in"></i>
                                            </a>

                                        )}
                                        {setting?.tiktok && (

                                            <a href={setting.tiktok} target="_blank" rel="noopener noreferrer">
                                                <i className="fab fa-tiktok"></i>
                                            </a>

                                        )}
                                        {setting?.twitter && (

                                            <a href={setting.twitter} target="_blank" rel="noopener noreferrer">
                                                <i className="fab fa-twitter"></i>
                                            </a>
                                        )}
                                    </div>
                                </div>
                            </aside>
                        </div>
                    </div>
                </div>
            </div>

        </main>
    );
}

export default BlogDetails;